import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import '../../asset/css/stepbystepform.css';
import {
    fetchUtilData,
    handleInput,
    renderListPrivate,
    renderForm, removeEntry
} from "../generic/databases-function";
import {GetUserToken} from "../../api/services";
import eConfig from "../../config";

const options = ["yes", "no"];
const optionsCountry = ["usa", "sa", "congo", "DRC"];

export default class ComFieldLocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Locations: [],
            newEntry: {},
            showList: true,
            cqlTable: "Locations",
            cqlTableRef: "Locations",
            listField: [
                {
                    field: "Name",
                    label: "Name",
                    options: options,
                    type: "text",
                    required: true
                },
                {
                    field: "Latitude",
                    label: "Latitude",
                    options: options,
                    type: "float",
                    required: true
                },
                {
                    field: "Longitude",
                    label: "Longitude",
                    options: options,
                    type: "float",
                    required: true
                },
                {
                    field: "Country",
                    label: "Country",
                    options: optionsCountry,
                    type: "option",
                    required: true
                },
                {
                    field: "Province",
                    label: "Province",
                    options: options,
                    type: "text",
                    required: true
                },
                {
                    field: "City",
                    label: "City",
                    options: options,
                    type: "text",
                    required: true
                },
                {
                    field: "Suburb",
                    label: "Suburb",
                    options: options,
                    type: "text",
                    required: true
                },
                {
                    field: "Address",
                    label: "Address",
                    options: options,
                    type: "text",
                    required: true
                },
                {
                    field: "AreaCode",
                    label: "Area Code",
                    options: options,
                    type: "text",
                    required: false
                },
                {
                    field: "PostalCode",
                    label: "Postal Code",
                    options: options,
                    type: "text",
                    required: false
                },
            ]

        }
    }

    async componentDidMount() {
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await fetchUtilData(this,"otp", "Locations", "Locations");
    }

    fetchApi = async (url, hub, method, callback) => {
        console.log("$$$$$----> ", url);
        fetch(url, {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((response) => {
                callback(response, null);
            }).catch((e) => {
            callback(null, e, null);
        });
    }

    submitEntry = async (e, table, addData, _this) => {
        e.preventDefault();
        if (!window.confirm("Are you sure that you want to submit?")) {
            return
        }

        let entry = {..._this.state.newEntry};
        entry.Org = GetUserToken().OrgCode;
        for (let i in addData) {
            const row = addData[i];
            if (typeof row.type !== "undefined") {
                if (row.type === "hidden") {
                    entry[row.field] = row.defaultValue;
                }
                if(row.type==="float"){
                    entry[row.field]=parseFloat(entry[row.field])
                }
            }
        }
        //todo let add our default variable

        let hub = {...entry};

        let backend = eConfig.otpBackend;
        let endpoint = "/api/locations/new";
        let url = eConfig.serverBackendOtp + "/" + backend + endpoint;

        await this.fetchApi(url, hub, "POST", async (dataIn, err) => {
            console.log("submitEntry *** response > ", dataIn);
            if (dataIn !== null) {
                if (typeof dataIn.RESULT !== "undefined") {
                    alert("Thank you Record submitted!");
                    let tmp = _this.state;
                    tmp.showList = true;
                    _this.setState(tmp);
                    await _this.loadInitialData();
                }
            }

        });

    }

    renderList = () => {
        const keyList = [];
        for (let i in this.state.listField) {
            const row = this.state.listField[i];
            keyList.push({
                field: row.field.toLocaleLowerCase(),
                label: row.field.toLocaleUpperCase()
            });
        }
        console.log("listField %%%%%%--->",keyList);
        const deleteKey = ["org", "name"];
        const deleteTable = "Locations";
        const sortKey = "position";
        return renderListPrivate(this, "Locations", keyList, deleteKey, deleteTable, "showList", removeEntry, sortKey)
    }
    renderForm = () => {
        return renderForm(this.state.listField, "showList", this.state.cqlTable, this, this.submitEntry)
    }

    render() {

        let _this = this;
        return (
            <PageContentWallpaper {...this.props} >


                <div>

                    <div className="row">
                        <div className="col col-xs-12">
                            <h3>
                                Setup Locations

                                {this.state.showList ?
                                    <a className={"btn btn-primary pull-right"}
                                       onClick={(e) => handleInput(e, "showList", false, _this)}>Add New Record</a>
                                    :
                                    <a className={"btn btn-danger pull-right"}
                                       onClick={(e) => handleInput(e, "showList", true, _this)}>Cancel Adding new
                                        Record</a>
                                }
                            </h3>
                        </div>
                    </div>

                    {this.state.showList ? this.renderList() : this.renderForm()}
                </div>
            </PageContentWallpaper>
        )
    }


}
